import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from '../sas-management.constants';

@Component({
  selector: 'app-sas-management-change-password-sent',
  templateUrl: './sas-management-change-password-sent.component.html',
  styleUrls: [
    '../style/global.css',
    './sas-management-change-password-sent.component.css',
  ],
})
export class SasManagementChangePasswordSentComponent implements OnInit {
  email: string | null = null;
  constructor() {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  ngOnInit(): void {}
}
